module.exports = __webpack_public_path__ + "static/media/call-feedback-dishonest-contributor-grey.e0a104f6.svg";